module.exports = __webpack_public_path__ + "static/media/usa.f8d3fba8.svg";